module.exports = __webpack_public_path__ + "static/media/work (2).a00c670f.jpg";